export enum SPOG_Features {
  DEVICES = 'devices',
  USERS = 'users',
  GROUPS = 'groups',
  ORGUNITS = 'orgunits',
  CLASSROOMS = 'classrooms',
}

export enum CLAIM_PROVIDER {
  GOOGLE = 'google',
}

export interface CLAIM_PROVIDER_DETAILS {
  providerId: number;
  customerId: string;
  /** Google Directory user id of the provider account. */
  googleUserId?: string;
  /**
   * @deprecated Pre-rename token field. Retained only so readers can shim
   * (`googleUserId ?? userId`) for ID tokens issued before the rename; remove
   * once all issued tokens have cycled.
   */
  userId?: string;
  primaryEmail?: string;
}

export interface AUTHENTICATION_CLAIMS {
  /**
   * Google Workspace customer ID (e.g., 'C04cu9ga4')
   * This is the string identifier used in Firestore document paths
   */
  googleCustomerId: string;
  /**
   * Numeric customer ID for backward compatibility
   * Prefer using googleCustomerId for new code
   */
  cdwCustomerId: string;
  core: {
    /**
     * Numeric customer ID from the database
     * For Firestore paths, use providers.google.customerId instead
     */
    customerId: number;
    /**
     * Firebase UID - stable identifier for authentication and audit logging
     * This never changes even if the user's database record is modified
     */
    firebaseUserId: string;
    /**
     * Database user ID from the users table
     * Use this for database queries and foreign key relationships
     */
    dbUserId: number;
    email: string;
    name: string;
    sessionId: string;
    features: SPOG_Features[];
    customer: {
      name?: string;
      timezone: string;
      dateFormat: string;
    };
  };
  /**
   * Provider-specific details
   * Use providers.google.customerId for Google Workspace customer ID (e.g., 'C04cu9ga4')
   */
  providers: Record<CLAIM_PROVIDER, CLAIM_PROVIDER_DETAILS>;
}
